import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function AdminSidebar({ user, onLogout }) {
  const location = useLocation();

  const navItems = [
    { path: '/admin/social',    icon: '📱', label: 'Social Media' },
    { path: '/admin/marketing', icon: '📣', label: 'Marketing' },
    { path: '/admin',           icon: '📅', label: 'Schedule' },
  ];

  return (
    <aside className="ah-sidebar">
      <div className="ah-sidebar-logo">
        <div className="ah-bowl-icon">🎳</div>
        <div>
          <h2 className="ah-sidebar-title">SKYLANES</h2>
          <p className="ah-sidebar-sub">Admin Panel</p>
        </div>
      </div>

      <nav className="ah-sidebar-nav">
        {navItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`ah-nav-item${location.pathname === item.path ? ' ah-nav-active' : ''}`}
          >
            <span className="ah-nav-icon">{item.icon}</span>
            <span className="ah-nav-label">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="ah-sidebar-footer">
        <div className="ah-footer-email">{user?.email}</div>
        <button onClick={onLogout} className="ah-logout-btn">Sign Out</button>
      </div>
    </aside>
  );
}

export default AdminSidebar;
